export default __webpack_public_path__ + "static/media/edit_road.72cd541e.svg";